import Index from './modules/index';

export default {
	namespaced: true,
	state: () => ({}),
	mutations: {},
	actions: {},
	getters: {},

	//	嵌套模块,继承父模块的命名空间
	modules: {
		Index,
	},
};



// WEBPACK FOOTER //
// ./src/store/Mall/index.js